import { useTranslation } from 'react-i18next';
import { RadioGroup, Switch } from '@asset-metrix/portal-ui';
import { useShallow } from 'zustand/react/shallow';

import {
  getMetadataExtractionOptions,
  METADATA_EXTRACTION_TYPE,
} from './constants';
import { useDocUploadStore } from './store';

import styles from '../docUpload/doc-upload-modal.module.scss';

export function MetadataExtractionConfiguration({
  extractionMethod,
  inputsDisabled = false,
  userEnabledPatternBasedRenaming,
  setExtractionMethod,
  setUserEnabledPatternBasedRenaming,
}: {
  extractionMethod: METADATA_EXTRACTION_TYPE;
  inputsDisabled?: boolean;
  userEnabledPatternBasedRenaming: boolean;
  setExtractionMethod: React.Dispatch<
    React.SetStateAction<METADATA_EXTRACTION_TYPE>
  >;
  setUserEnabledPatternBasedRenaming: React.Dispatch<
    React.SetStateAction<boolean>
  >;
}) {
  const {
    aiExtractionEnabled,
    enablePatternBasedRenaming: configEnablePatternBasedRenaming,
    fileNameMetadataExtractionEnabled,
    isTableModalValuesLoading,
  } = useDocUploadStore(
    useShallow((state) => ({
      aiExtractionEnabled: state.aiExtractionEnabled,
      enablePatternBasedRenaming: state.enablePatternBasedRenaming,
      fileNameMetadataExtractionEnabled:
        state.fileNameMetadataExtractionEnabled,
      isTableModalValuesLoading: state.isTableModalValuesLoading,
    }))
  );

  const { t } = useTranslation();
  if (!configEnablePatternBasedRenaming && !aiExtractionEnabled) {
    return null;
  }

  return (
    <div className={styles['metadata-extraction-container']}>
      {configEnablePatternBasedRenaming && (
        <Switch
          checked={userEnabledPatternBasedRenaming}
          disabled={inputsDisabled || isTableModalValuesLoading}
          label={t('app.upload.metadataExtractinConfig.renameFilesLabel')}
          onChange={setUserEnabledPatternBasedRenaming}
        />
      )}
      {aiExtractionEnabled && (
        <>
          <div className={styles['metadata-label-container']}>
            <label>{t('app.upload.metadataExtractinConfig.label')}</label>
            <div className={styles['metadata-label-divider']}></div>
          </div>
          <RadioGroup
            disableRadioGroup={inputsDisabled || isTableModalValuesLoading}
            options={getMetadataExtractionOptions(
              aiExtractionEnabled,
              fileNameMetadataExtractionEnabled
            )}
            onChange={(value) =>
              setExtractionMethod(value as METADATA_EXTRACTION_TYPE)
            }
            value={extractionMethod}
          />
        </>
      )}
    </div>
  );
}
